
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Custom Loading" fileName="custom.md" />
        <p>You can also customize the loading text, background color and size</p>
<demo-block>
        <div><p>1、<code>color</code> Set the color of the loading effect<br>2、<code>tip</code>Set loading text<br>2、<code>overlayBackgroundColor</code>Set mask background color，Can be specified by <a href="https://www.w3schools.com/cssref/func_rgba.asp">rgba</a>,Make the background transparent.</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;show()&quot;&gt;Open&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;close()&quot;&gt;Close&lt;/button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;div
            id=&quot;custom-loading-container&quot;
            style=&quot;width:100%;height:250px;background-color:#2980b9;&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data() {
            return {
                loadingInstance: null,
            };
        },
        methods: {
            show() {
                this.loadingInstance.show();
            },
            close() {
                this.loadingInstance.close();
            },
        },
        mounted() {
            this.loadingInstance = this.$veLoading({
                target: document.querySelector(&quot;#custom-loading-container&quot;),
                name: &quot;wave&quot;,
                color: &quot;#fff&quot;,
                tip: &quot;loading...&quot;,
                overlayBackgroundColor: &quot;rgba(255, 255, 255, 0.1)&quot;,
            });
            this.show();
        },
        destroyed() {
            this.loadingInstance.destroy();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.show()}}},[_vm._v("Open")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.close()}}},[_vm._v("Close")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"250px","background-color":"#2980b9"},attrs:{"id":"custom-loading-container"}})])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                loadingInstance: null,
            };
        },
        methods: {
            show() {
                this.loadingInstance.show();
            },
            close() {
                this.loadingInstance.close();
            },
        },
        mounted() {
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#custom-loading-container"),
                name: "wave",
                color: "#fff",
                tip: "loading...",
                overlayBackgroundColor: "rgba(255, 255, 255, 0.1)",
            });
            this.show();
        },
        destroyed() {
            this.loadingInstance.destroy();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  